import { render, staticRenderFns } from "./LatestNoticeForOfficeList.vue?vue&type=template&id=4bb85c0c&"
import script from "./LatestNoticeForOfficeList.vue?vue&type=script&lang=js&"
export * from "./LatestNoticeForOfficeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports